export default __webpack_public_path__ + "static/media/27.6b87de9c.png";